import * as React from 'react';
import {
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  TextField,
} from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import ConfirmModal from './ConfirmModal';
import DateTimeModal from './DateTimeModal';
import moment from 'moment';
import {
  GetLicenisingListApi,
  getTimesAvailable,
  NewBookAppointment,
} from '@api/appointmentApi';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from 'next/link';
import { sendEmail, sendEmailApi } from '@api/emailApi';
import { useApi, useSetFeedback } from 'use-hook-api';
import { company } from '@components/config/company/Details';

function DriverFormUpdated({ }) {
  const [LicensingAuthority, setLicensingAuthority] = React.useState([]);
  const [acceptTerms, setAcceptTerms] = React.useState(false);
  const [AvailableHours, { loading: timesLoader }] = useApi({
    errMsg: true,
    successMsg: false,
  });
  const [LicesingCouncil, { loading: liscenceLoader }] = useApi({
    errMsg: true,
    successMsg: false,
  });
  const [alreadyDriver, setAlreadyDriver] = React.useState(false);
  const matches = useMediaQuery('(min-width:625px)');
  const setFeedback = useSetFeedback();
  const [data, setData] = React.useState({});
  const [state, setState] = React.useState({
    firstName: '',
    previousDriverNum: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    licensing_council: '',
  });
  const onStateChange = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrorState((prevState) => ({
      ...prevState,
      [name]: false,
    }));
  };
  const [errorState, setErrorState] = React.useState({
    firstName: false,
    previousDriverNum: false,
    lastName: false,
    email: false,
    phone: false,
    licensing_council: false,
    insurance: false,
    mot: false,
    plate_paperwork: false,
    photo_badge: false,
    driver_license: false,
    badge_paperwork: false,
  });
  const onErrorStateChange = (name, value) => {
    setErrorState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const [time, setTime] = React.useState();
  const [value, setValue] = React.useState();
  const [dateTimeModal, setDateTimeModal] = React.useState(false);
  const [confirmModal, setConfirmModal] = React.useState(false);
  const [selectedDateTime, setSelectedDateTime] = React.useState(null);
  const [contactUs, { loading: contactLoader }] = useApi({
    errMsg: true,
    successMsg: true,
    resSuccessMsg: 'Appointment confirmed.',
  });
  const [BookAppointmentApi, { loading: bookLoader }] = useApi({
    errMsg: true,
    successMsg: true,
    resSuccessMsg: ['Thankyou! See You Soon'],
  });
  const [emailFun, { loading: emailLoader }] = useApi({
    errMsg: false,
    successMsg: false,
  });
  const [checkList, setCheckList] = React.useState([]);
  const onCheckListChange = (e) => {
    if (e.target.checked) {
      setCheckList([...checkList, e.target.name]);
      onErrorStateChange(e.target.name, true);
    } else {
      setCheckList(checkList.filter((item) => item !== e.target.name));
      onErrorStateChange(e.target.name, false);
    }
  };
  const onModalClose = () => {
    setConfirmModal(false);
    setSelectedDateTime(null);
    // window.location.reload();
  };

  const onConfirm = (date, time) => {
    setDateTimeModal(false);
    //Tuesday 11 April 2023 formate this formate
    let dateFormate = moment(date).format('dddd DD MMMM YYYY');
    setSelectedDateTime(dateFormate + ' ' + time);
  };
  const onSubmit = () => {
    let pass = true;
    if (alreadyDriver === true) {
      if (state.previousDriverNum === '') {
        onErrorStateChange('previousDriverNum', true);
        setFeedback([`All Fields Are Required`, 'error']);
        pass = false;
      }
    }
    if (selectedDateTime === '' || selectedDateTime === null) {
      setFeedback(['Please select a date and time.'], 'error');
      pass = false;
    }
    if (state.firstName === '') {
      onErrorStateChange('firstName', true);

      setFeedback([`All Fields Are Required`, 'error']);
      pass = false;
    }
    if (state.lastName === '') {
      onErrorStateChange('lastName', true);
      setFeedback([`All Fields Are Required`, 'error']);
      pass = false;
    }
    if (state.email === '') {
      onErrorStateChange('email', true);
      setFeedback([`All Fields Are Required`, 'error']);
      pass = false;
    }
    if (
      state.phone === '' ||
      state.phone === undefined ||
      state.phone === null ||
      state.phone === '+'
    ) {
      onErrorStateChange('phone', true);
      setFeedback([`Please enter your phone number`, 'error']);

      pass = false;
    }

    if (state.licensing_council === '') {
      onErrorStateChange('licensing_council', true);
      setFeedback(['All Fields Are Required.'], 'error');
      pass = false;
    }

    if (
      errorState.insurance === false ||
      errorState.mot === false ||
      errorState.plate_paperwork === false ||
      errorState.photo_badge === false ||
      errorState.driver_license === false ||
      errorState.badge_paperwork === false
    ) {
      setFeedback(['All Fields Are Rquired including checklist.'], 'error');
      pass = false;
    }
    if (pass === true && acceptTerms === false) {
      setFeedback(['Please accept our terms and Privacy Policy'], 'error');
      pass = false;
    }
    if (pass === true) {
      const ApiData = {
        name: state.firstName + ' ' + state.lastName,
        phone: state.phone,
        email: state.email,
        licensing_council: state.licensing_council,
        address: state.address,
        timeRequired: alreadyDriver ? '30 mins' : '40 mins',
        // date: ConvertToUTC(data),
        date: data,
      };
      checkList.forEach((item) => {
        ApiData[item] = true;
      });
      alreadyDriver ? (ApiData['existingDriverCheck'] = true) : null;
      alreadyDriver
        ? (ApiData['previousDriverNumber'] = state.previousDriverNum)
        : null;
      BookAppointmentApi(NewBookAppointment(ApiData), () => {
        const EmailApiData = {
          support_email: company.compnay_support_email,

          recipient: [state.email],

          message: ` Thank you <b>${state.firstName} ${state.lastName}</b>.<br/>You have booked an appointment with our driver onboarding team on ${selectedDateTime}.<br/> You can find us at ${company.address.building} ${company.address.street} ${company.address.town} ${company.address.postcode}.<br/><br/> Please make sure to have all necessary documents with you and arrive 15 minutes in advance.<br/><br/> We look forward to meet you!<br/><br/>Best Regards,<br/>${company.name}`,

          subject: 'Appointment Confirmation',

          rich_text: true,
        };
        emailFun(sendEmailApi(EmailApiData));
        setConfirmModal(true);
        setData(null);
        setCheckList([]);
        setValue();
        setTime();
        setAcceptTerms(false);
        setAlreadyDriver(false);
        setState({
          firstName: '',
          previousDriverNum: '',
          lastName: '',
          email: '',
          phone: '+44',
          address: '',
          licensing_council: '',
        });
        setErrorState({
          firstName: false,
          previousDriverNum: false,
          lastName: false,
          email: false,
          phone: false,
          address: false,
          licensing_council: false,
          insurance: false,
          mot: false,
          plate_paperwork: false,
          photo_badge: false,
          driver_license: false,
          badge_paperwork: false,
        });
      });
    }
  };
  const onDateTimeClick = () => {
    AvailableHours(getTimesAvailable(), (result) => {
      if (result?.data?.results.length > 0) {
        setDateTimeModal(true);
      } else {
        setFeedback([
          `We are not available for appoinments at the moment. Please contact us on ${company.tel_number}`,
          'error',
        ]);
      }
    });
  };
  React.useEffect(() => {
    LicesingCouncil(GetLicenisingListApi(), (result) => {
      console.log(result);
      const temp = [];
      result?.data?.results.forEach((item) => {
        temp.push(item.name);
      });
      setLicensingAuthority(temp);
    });
  }, []);
  return (
    <div className="bg-white rounded-2xl p-5  ">
      <div>
        <div className="text-xl font-bold text-center ">
          BECOME A {company.name} TAXIS DRIVER
        </div>
      </div>
      <div className="text-center my-4">
        Book an appointment with our driver onboarding
        <br /> team by filling out the details below.
      </div>
      <div className="mt-5">
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2 flex items-center">
            <Checkbox
              name="existingDriver"
              checked={alreadyDriver}
              onClick={() => {
                setAlreadyDriver(!alreadyDriver);
              }}
            />
            <div>Returning {company.name} driver?</div>
          </div>
          {alreadyDriver ? (
            <div className="col-span-2 ">
              <div className="text-md my-2 font-semibold">
                Welcome Back. Please enter your previous driver number
              </div>
              <TextField
                value={state.previousDriverNum}
                name="previousDriverNumber"
                variant="outlined"
                size="small"
                className="w-full"
                error={errorState.previousDriverNum}
                onChange={(e) => {
                  onStateChange('previousDriverNum', e.target.value);
                }}
              />
            </div>
          ) : null}
          <div className="col-span-2 md:col-span-1">
            <div className="text-md my-2 font-semibold">First Name *</div>
            <TextField
              name="firstName"
              value={state.firstName}
              variant="outlined"
              size="small"
              error={errorState.firstName}
              className="w-full"
              onChange={(e) => {
                onStateChange('firstName', e.target.value);
              }}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <div className="text-md my-2 font-semibold">Last Name *</div>
            <TextField
              name="lastName"
              value={state.lastName}
              variant="outlined"
              size="small"
              error={errorState.lastName}
              className="w-full"
              onChange={(e) => {
                onStateChange('lastName', e.target.value);
              }}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <div className="text-md my-2 font-semibold">Email *</div>
            <TextField
              name="email"
              value={state.email}
              type="email"
              variant="outlined"
              size="small"
              error={errorState.email}
              className="w-full"
              onChange={(e) => {
                onStateChange('email', e.target.value);
              }}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <div className="text-md my-2 font-semibold">Phone Number *</div>
            {/* <TextField
                            name="phone"
                            value={state.phone}
                            variant="outlined"
                            size="small"
                            className="w-full"
                            error={errorState.phone}
                            onChange={(e) => { onStateChange('phone', e.target.value) }}
                        /> */}
            <PhoneInput
              country={'gb'}
              value={state.phone}
              buttonStyle={{
                backgroundColor: 'inherit',
                borderColor: errorState.phone ? 'red' : '#B7B7B7',
              }}
              inputStyle={{
                width: '100%',
                backgroundColor: 'inherit',
                borderColor: errorState.phone ? 'red' : '#B7B7B7',
              }}
              onChange={(phone) => onStateChange('phone', `+${phone}`)}
            />
          </div>
          <div className="col-span-2">
            <div>
              <div className="text-md my-2 font-semibold">
                Address <span className="text-gray text-xs">(optional)</span>
              </div>
              <TextField
                name="address"
                value={state.address}
                variant="outlined"
                size="small"
                className="w-full"
                onChange={(e) => {
                  onStateChange('address', e.target.value);
                }}
              />
            </div>
          </div>
          <div className="col-span-2">
            <div>
              <div className="text-md my-2 font-semibold">
                Licensing Council *
              </div>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                value={state.licensing_council}
                aria-required
                onChange={(e, value) =>
                  onStateChange('licensing_council', value)
                }
                options={LicensingAuthority}
                size="small"
                renderInput={(params) => (
                  <TextField
                    required
                    error={errorState.licensing_council}
                    variant="outlined"
                    size="small"
                    {...params}
                    fullWidth
                  />
                )}
              />
            </div>
          </div>

          <div className="col-span-2">
            <div className="text-lg">
              Please tick these item to confirm you will bring these with you
              when you attend your appointment.
            </div>
            <div className="mt-2 grid md:grid-cols-2  xl:grid-cols-3 ">
              <FormControlLabel
                control={
                  <Checkbox
                    name="insurance"
                    checked={checkList.includes('insurance') ? true : false}
                    onChange={onCheckListChange}
                  />
                }
                label="Insurance *"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name="mot"
                    checked={checkList.includes('mot') ? true : false}
                    onChange={onCheckListChange}
                  />
                }
                label="MOT certificate *"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name="plate_paperwork"
                    checked={
                      checkList.includes('plate_paperwork') ? true : false
                    }
                    onChange={onCheckListChange}
                  />
                }
                label="Plate Paperwork *"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="photo_badge"
                    checked={checkList.includes('photo_badge') ? true : false}
                    onChange={onCheckListChange}
                  />
                }
                label="Photo Badge *"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="driver_license"
                    checked={
                      checkList.includes('driver_license') ? true : false
                    }
                    onChange={onCheckListChange}
                  />
                }
                label="Drivers License *"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="badge_paperwork"
                    checked={
                      checkList.includes('badge_paperwork') ? true : false
                    }
                    onChange={onCheckListChange}
                  />
                }
                label="Badge Paperwork *"
              />
            </div>
            <div className="col-span-2 ">
              <Checkbox
                className="-ml-3"
                checked={acceptTerms}
                onClick={() => setAcceptTerms(!acceptTerms)}
              />
              By joining {company.name}, you accept our{' '}
              <Link href={'/legal/policy/privacy'} className="text-secondary hover:underline">
                Privacy Policy
              </Link>
              .
            </div>
          </div>
          <div className="col-span-2">
            <div>
              <div className="text-md my-2 font-semibold">Date And Time *</div>

              <div className="grid md:grid-cols-4 gap-4">
                <div
                  className={`${selectedDateTime ? 'md:col-span-3' : 'md:col-span-4'
                    }`}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      onDateTimeClick();
                    }}
                    fullWidth
                    className="text-md hover:bg-secondary text-white bg-secondary"
                  >
                    {selectedDateTime === null ? (
                      timesLoader ? (
                        <CircularProgress size={20} className="text-white" />
                      ) : (
                        'make an appointment'
                      )
                    ) : timesLoader ? (
                      <CircularProgress size={24} className="text-white" />
                    ) : (
                      <div>
                        <span>Appointment On </span>
                        <span className="text-lg font-semibold">
                          &nbsp;
                          {selectedDateTime}&nbsp;
                        </span>
                        <span> for &nbsp;</span>

                        {state.timeRequired === 0 ? '30 Min' : '45 Min'}
                      </div>
                    )}
                  </Button>
                </div>
                {selectedDateTime && (
                  <Button
                    variant="outlined"
                    className="text-md hover:bg-green-600 text-white bg-green-600"
                    onClick={() => {
                      onSubmit();
                    }}
                    fullWidth
                  >
                    {bookLoader ? <CircularProgress size={24} /> : 'Confirm'}
                  </Button>
                )}
              </div>
            </div>
          </div>
          {/* <div className="col-span-2 mt-4">
                        <Button
                            disabled={bookLoader}
                            type="submit"
                            onClick={() => {
                                onSubmit();
                            }}
                            disableElevation
                            fullWidth
                            variant="contained"
                            className="bg-primary hover:bg-primary/80 font-bold transition-all"
                        >
                            {bookLoader ? <CircularProgress /> : 'Confirm Appointment'}
                        </Button>
                    </div> */}
        </div>
      </div>

      <ConfirmModal
        timeRequired={state.timeRequired}
        dateTime={selectedDateTime}
        name={state.name}
        date={state.date}
        open={confirmModal}
        handleClose={onModalClose}
      />
      {dateTimeModal && (
        <DateTimeModal
          timeRequired={state.timeRequired}
          onCrossClick={() => {
            setDateTimeModal(false);
          }}
          time={time}
          setTime={setTime}
          value={value}
          setValue={setValue}
          open={dateTimeModal}
          onConfirm={onConfirm}
          setTimeRequired={(val) => {
            setState({ ...state, timeRequired: val });
          }}
          setData={setData}
          onClose={() => {
            setDateTimeModal(false);
          }}
        />
      )}
    </div>
  );
}

export default DriverFormUpdated;
